/***
*
*   ACCOUNT NAV
*   Acount sub nav that renders different options based
*   on user permissions. Shows billing & user admin to only account owners
*
**********/

import { useContext } from 'react';
// Components import.
import { SubNav, AuthContext, useTranslation, usePlans } from 'components/lib';


export function AccountNav(props) {
  const { t } = useTranslation();
  const context = useContext(AuthContext);
  const allPlans = usePlans();
  const plan = allPlans?.data?.raw?.plans.find((x) => x.id === context?.user?.plan);

  const navItems = [
    { link: '/account/profile', label: t('account.nav.profile'),permission:'account.profile.view' },
    { link: '/account/password', label: t('account.nav.password'),permission:'account.password.view' },
    { link: '/account/2fa', label: t('account.nav.2fa') ,permission:'account.2fa.view'},
    { link: '/account/apikeys/', label: t('account.nav.api_keys'), permission: 'account.apikeys.view' },
    { link: '/account/users', label: t('account.nav.users'), permission: 'account.users.view' },

  ]

  if (context?.user?.lms_enabled) {
    navItems.splice(4, 0, { link: '/account/hierarchy', label: t('account.nav.hierarchy'), permission: 'account.hierarchy.view' })
  }
  if (plan?.payment_method !== 'external') {
    navItems.splice(3, 0, { link: '/account/billing', label: t('account.nav.billing'), permission: 'account.orgbilling.view' })
  }
  //TODO Need to Remove this code block on LMS plans phase out
  if (!plan?.lms_only && plan?.enterprise) {
    navItems.push({ link: '/account/lpath', label: t('account.nav.LearningPath'), permission: 'account.lpath.view' });
  }
  return (
    <SubNav items={navItems} />
  );
}